(() => {
// src/app.js
$(".live-chat-button").click(function() {
    $("#CHS_chat_btn").click();
});
$(document).ready(function() {
    if ($(".bswa-chat").length) setTimeout(function() {
        var all = document.getElementsByClassName("bswa-chat");
        for(var i = 0; i < all.length; i++)all[i].style.display = "block";
    }, 1000);
});
$(".mobilenav-trigger").on("click", function() {
    if ($(".mobilenav-trigger").hasClass("navOpen")) {
        $(".mobilenav-inner").css("bottom", "-120vh");
        $(".mobilenav-trigger").removeClass("navOpen");
        $(".closed").removeClass("hidden");
        $(".open").addClass("hidden");
        $(".symbol-closed").css("display", "block");
        $(".symbol-open").css("display", "none");
    } else {
        $(".mobilenav-inner").css("bottom", "0");
        $(".mobilenav-trigger").addClass("navOpen");
        $(".open").removeClass("hidden");
        $(".closed").addClass("hidden");
        $(".symbol-open").css("display", "block");
        $(".symbol-closed").css("display", "none");
    }
});
//  Feedback Form
const $185ee067a0fab524$var$feedbackForm = document.querySelector("#feedback-form");
if ($185ee067a0fab524$var$feedbackForm) setTimeout(function() {
    $185ee067a0fab524$var$openFeedbackForm();
}, 5000);
function $185ee067a0fab524$var$openFeedbackForm() {
    if (localStorage.getItem("feedback-form") !== "submitted") {
        localStorage.setItem("feedback-form", "open");
        $185ee067a0fab524$var$feedbackForm.classList.remove("translate-y-full", "opacity-0");
        const closeButton = $185ee067a0fab524$var$feedbackForm.querySelector(".close");
        closeButton.onclick = function() {
            $185ee067a0fab524$var$closeFeedbackForm();
        };
        jQuery(document).on("gform_confirmation_loaded", function() {
            localStorage.setItem("feedback-form", "submitted");
            setTimeout(function() {
                $185ee067a0fab524$var$closeFeedbackForm();
            }, 5000);
        });
    }
}
function $185ee067a0fab524$var$closeFeedbackForm() {
    if (localStorage.getItem("feedback-form") !== "submitted") localStorage.setItem("feedback-form", "closed");
    $185ee067a0fab524$var$feedbackForm.classList.add("translate-y-full", "opacity-0");
}
// FAQs
const $185ee067a0fab524$var$faqs = document.querySelectorAll("#faqs > article");
$185ee067a0fab524$var$faqs.forEach((item)=>{
    let state = false;
    const toggle = item.querySelector(item.dataset.trigger);
    const chevron = item.querySelector(item.dataset.icon);
    const body = item.querySelector(item.dataset.content);
    toggle.addEventListener("click", ()=>{
        if (state) {
            body.classList.add("hidden");
            chevron.classList.add("fa-chevron-up");
            chevron.classList.remove("fa-chevron-down");
        } else {
            body.classList.remove("hidden");
            chevron.classList.remove("fa-chevron-up");
            chevron.classList.add("fa-chevron-down");
        }
        state = !state;
    });
});

})();
//# sourceMappingURL=app.js.map
